class LangService {
    constructor(){
        this._defaultLocale = 'ua';
        this._locale = this._defaultLocale;
    }

    getDefaultLocale() {
        return this._defaultLocale;
    }

    getLocale(){
        return this._locale;
    }

    setLocale(locale) {
        this.locale = locale;
    }

    getEnLetters() {
        return {
            'a': 'а',
            'b': 'б',
            'c': 'к',
            'd': 'д',
            'e': 'e',
            'f': 'ф',
            'g': 'г',
            'h': 'х',
            'i': 'и',
            'j': 'дж',
            'k': 'к',
            'l': 'л',
            'm': 'м',
            'n': 'н',
            'o': 'о',
            'p': 'п',
            'q': 'к',
            'u': 'у',
            'v': 'в',
            'w': 'в',
            'x': 'кс',
            'y': 'и',
            'z': 'з',
        }
    }

    getRuLetters() {
        return {
            'а': 'a',
            'б': 'b',
            'в': 'v',
            'г': 'g',
            'д': 'd',
            'е': 'e',
            'ж': 'zh',
            'з': 'z',
            'и': 'i',
            'к': 'k',
            'л': 'l',
            'м': 'm',
            'н': 'n',
            'о': 'o',
            'п': 'p',
            'р': 'r',
            'с': 's',
            'т': 't',
            'у': 'u',
            'ф': 'f',
            'х': 'h',
            'ц': 'ts',
            'ч': 'ch',
            'ь': '',
            'э': 'e',
            'ю': 'yu',
            'я': 'ya',
        }
    }

    getEnToRu(text) {
        let transText = '';

        for(let i of text.toLowerCase()) {
            let letter = this.getEnLetters()[i];

            if(letter)
                transText += letter;
        }

        return transText;
    }

    getRuToEn(text) {
        let transText = '';

        for(let i of text.toLowerCase()) {
            let letter = this.getRuLetters()[i];

            if(letter)
                transText += letter;
        }

        return transText;
    }
}

export default new LangService();
